import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MaterialModel } from 'src/app/modules/materials/models/material.model';

@Component({
  selector: 'liv-videos-offline',
  templateUrl: './videos-offline.component.html',
  styleUrls: ['./videos-offline.component.scss'],
  standalone: false
})
export class VideosOfflineComponent {
  @Input() videos$: Observable<MaterialModel[]>;
  activatedRoute: ActivatedRoute;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.activatedRoute = this.route;
  }

  onClick(serie: MaterialModel) {
    this.router.navigate([serie.path]);
  }
}
